export default "__VITE_ASSET__CV$ro$P6__"